import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import Loader from './components/Loader';
// Importing pages
import AboutUs from './pages/AboutUs';
import Commodities from './pages/Commodities';
import ContactUs from './pages/ContactUs';
import Homepage from './pages/Hompage';
import Services from './pages/Services';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on route change
  }, [location]);

  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // Simulate loading or page transition with a timer (you can adjust or remove this logic based on your app's needs)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Set to false after 3 seconds (adjust or remove as necessary)
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="App">
        {isLoading && <Loader />}
        
        {/* Scroll to top on route change */}
        <ScrollToTop />
        
        {/* Routes */}
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/commodities" element={<Commodities />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/services" element={<Services />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
